__webpack_require__.p = "/static/src/vue/dist/";